<style lang="less" scoped>
.footer {
  width: 100%;
  font-size: 12px;
  color: #ffffff;
  .footer-info {
    margin: 0 auto;
    text-align: center;
    p {
      a {
        margin-right: 15px;
      }
    }
  }
}
</style>

<template>
    <Footer class="footer">
        <section class="footer-info">
          footerContent
        </section>
    </Footer>
</template>

<script>
export default {
  name: 'cisFooter'
}
</script>
